import SkeletonLoader from '@/components/SkeletonLoader/SkeletonLoader.component';
import RedirectHandler from '@/providers/RedirectProvider';
import ProtectedRoute from './ProtectedRoute';

const RouteHandler = function ({
  element,
  nestedRoute,
  withLoading,
}: {
  element: JSX.Element;
  nestedRoute?: boolean;
  withLoading?: boolean;
}): JSX.Element {
  if (withLoading) {
    return (
      <SkeletonLoader>
        <RedirectHandler>
          <ProtectedRoute nestedRoute={nestedRoute} element={element} />
        </RedirectHandler>
      </SkeletonLoader>
    );
  }

  return (
    <RedirectHandler>
      <ProtectedRoute nestedRoute={nestedRoute} element={element} />
    </RedirectHandler>
  );
};

export default RouteHandler;
